module.exports = __webpack_public_path__ + "static/img/grayCamera.45d6c6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/grayCamera.png
// module id = QHWF
// module chunks = 1